import { useContext, useEffect, useState } from "react";
import styles from "./screenStart.module.scss";
import CurrentContext from "../utils/CurrentContext";
import Button from "./button";

function StartContent() {
  const {
    aspectRatio,
    setCurrentScreen,
    allImagineImages,
    allRealImages,
    getRandomSample,
    setQuizImages,
    answers,
    setAnswers,
    currentIndex,
    setCurrentIndex,
    name,
    setName,
    email,
    setEmail,
  } = useContext(CurrentContext);

  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValid(name.trim() !== "" && emailRegex.test(email));
  }, [name, email]);

  function HandleClick() {
    const sampleImagine = getRandomSample(allImagineImages, 5);
    const sampleReal = getRandomSample(allRealImages, 5);
    console.log("Selected Imagine Images:", sampleImagine);
    console.log("Selected Real Images:", sampleReal);

    const shuffled = [...sampleImagine, ...sampleReal].sort(
      () => Math.random() - 0.5
    );
    console.log("Final Shuffled Images for Round:", shuffled);

    setQuizImages(shuffled);
    setAnswers([]);
    setCurrentIndex(0);
    setCurrentScreen("instructions");
  }

  return (
    <>
      <div className={styles.text_wrapper}>
        {aspectRatio >= 1 ? (
          <>
            <p className={styles.startTitle}>Ready for a challenge?</p>
            <p>Let’s play a little game! You’ll see a set of images,</p>
            <p>
              but here’s the twist—some are real, and some were created by
              imagine.io.
            </p>
            <br />
          </>
        ) : (
          <img
            src="images/Home.jpg"
            alt="startImage"
            className={styles.hero_image}
            style={{ 
              width: "90vw", maxHeight: "768px", maxWidth: "768px" }}
          />
        )}

        <p className={styles.orange_text}>
          Can you spot the difference? Let’s find out!
        </p>
        <br />
        <div
          className={styles.start_input_wrapper}
          style={{ flexDirection: "column" }}
        >
          <input
            className={styles.start_input_data}
            type="text"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            className={styles.start_input_data}
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>
      <div className={styles.startBtnWrapper}>
        <Button label="Start" handleClick={HandleClick} isValid={isValid} />
      </div>
    </>
  );
}

export default function Start() {
  const { aspectRatio } = useContext(CurrentContext);
  return (
    <>
      {aspectRatio >= 1 ? (
        <div className={styles.start_wrapper}>
          <div className={styles.left_panel}>
            <img
              src="images/Home.jpg"
              alt="startImage"
              className={styles.hero_image}
            />
          </div>
          <div className={styles.right_panel}>
            <StartContent />
          </div>
        </div>
      ) : (
        <div className={styles.right_panel}>
          <div className={styles.vertical}>
            <StartContent />
          </div>
        </div>
      )}
    </>
  );
}
